export const getValueFromContent = (value, content, defaultValue) => {
  if (typeof value !== 'string') {
    return value;
  }
  const findPatternResult = /^{{(.+)}}$/.exec(value);

  if (findPatternResult) {
    const key = findPatternResult[1];
    return content[key] || value;
  } else if (!value) {
    return defaultValue;
  }

  return value;
};
